import React from 'react';
const Api = require('./Config');

export default class ActReport extends React.Component {
  getReportingPortalUrl() {
    const build = Api.getBuild();
    let url = '';

    if (build == 'LIVE') {
      url = 'https://reporting.cmdr-ops.com/';
    }
    if (build == 'LOCAL') {
      url = 'http://reporting.cmdr-ops.local';
    }
    if (build == 'STAGE') {
      url = 'https://stage.reporting.cmdr-ops.com/';
    }
    if (build == 'DEV') {
      url = 'https://dev.reporting.cmdr-ops.com';
    }

    return url;
  }

  render() {
    return <iframe src={this.getReportingPortalUrl()} height="1000px" width="100%" frameBorder={0}></iframe>;
  }
}
